import { useCallback, useState, useRef } from 'react'
import { useLocal } from '@/i18n/LocalContext'
import { useStore } from '@/store'
import { getSpecifiedSellData } from '@app/request'
import { getDefaultSellData } from '@app/store/sell'
import { $alert } from '@/utils'

export default function useSellData() {
  const { $t } = useLocal()
  const { state, dispatch } = useStore()
  const playerId = state.login.userInfo.playerId
  const targetPlayerId = state.targetPlayerId
  const tree = state.marketData.tree

  const [pending, setPending] = useState(false)
  const pendingRef = useRef(pending)

  const fetchSellData = useCallback(async () => {
    if (pendingRef.current) return

    pendingRef.current = true
    setPending(pendingRef.current)
    const data = await getSpecifiedSellData({
      playerId,
      targetPlayerId,
      tree,
    })
    if (data.list.length > 0 && data.list[0].overage <= 0) {
      dispatch({
        type: 'setState',
        data: {
          specifiedSellData: {
            ...getDefaultSellData(),
            tree,
          },
        },
      })
      $alert($t('当前玩家集市已售罄'))
    } else {
      const actionData: Partial<typeof state> = { specifiedSellData: data }
      if (data.list.length === 0) {
        actionData.targetPlayerId = ''
      }
      dispatch({ type: 'setState', data: actionData })
    }
    pendingRef.current = false
    setPending(pendingRef.current)

    return data
  }, [playerId, targetPlayerId, tree])

  return {
    pending,
    fetchSellData,
  }
}
